//
// locales/vanilla/io.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/io.json';
import localeData from 'react-intl/locale-data/io.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
